import { AbstractControl } from '@angular/forms';

export class CustomValidator{
  // Number only validation
  static numeric(control: AbstractControl) {
    const val = control?.value;
    
    
    if (val == null || val == '') {return null;} // NOSONAR
    
    if (!val?.toString().match(/^[0-9]+(\.?[0-9]+)?$/)) {return { 'invalidNumber': true };}
    
    return null;
  } 

  static anyIncident (control: AbstractControl) {
    const val = control?.value;
    if (val == null || val == '') { return null;} // NOSONAR
    const incidentFound = val?.find(element => element !=   false)          // NOSONAR
    if (incidentFound == undefined){ return { 'incidentNotFound': true };} // NOSONAR
    return null;
  }
}